export const environment = {
  production: true,
  //apiBase: 'https://localhost:44304/api'
  //apiBase: 'https://uat.medicines.org.au/api'
  apiBase: 'https://medicines.org.au/api'
};
